/**
 * Normalize Circa Social feed posts so quote/bare embeds survive mapping.
 * Shared by Home, profiles, and community feeds.
 */

function nestEmbed(inner, nestDepth = 0) {
  if (!inner || nestDepth >= 2) return null;
  if (inner.unavailable) return { ...inner };
  const iid =
    inner.social_post_id ??
    inner.post_id ??
    inner.postId ??
    inner.socialPostId ??
    null;
  if (iid == null) return null;
  const nested = nestEmbed(
    inner.repost_of || inner.repostOf,
    nestDepth + 1
  );
  return {
    ...inner,
    post_id: iid,
    social_post_id: iid,
    title: inner.repost_kind === "quote" ? null : inner.title ?? null,
    like_count: inner.like_count ?? inner.likeCount ?? 0,
    reply_count: inner.reply_count ?? inner.replyCount ?? 0,
    repost_count: inner.repost_count ?? inner.repostCount ?? 0,
    viewer_has_reposted: Boolean(inner.viewer_has_reposted),
    viewer_has_liked: Boolean(inner.viewer_has_liked),
    repost_kind: inner.repost_kind ?? inner.repostKind ?? null,
    repost_of_social_post_id:
      inner.repost_of_social_post_id ??
      inner.repostOfSocialPostId ??
      null,
    repost_of: nested,
    social_author: inner.social_author || inner.socialAuthor || null,
    author_org: inner.author_org || inner.authorOrg || null,
    user: inner.is_official ? null : inner.user || null,
    community: inner.community || null,
    community_id:
      inner.community_id ?? inner.community?.community_id ?? null,
    deleted_at: inner.deleted_at || inner.deletedAt || null,
  };
}

/**
 * @param {object} p - raw API social post
 * @returns {object}
 */
export function normalizeSocialFeedPost(p) {
  if (!p) return p;
  const id = p.social_post_id ?? p.post_id ?? p.postId ?? p.socialPostId;
  const repostOfId =
    p.repost_of_social_post_id ?? p.repostOfSocialPostId ?? null;
  const repostOf = nestEmbed(p.repost_of || p.repostOf || null, 0);

  return {
    ...p,
    post_id: id,
    social_post_id: id,
    title:
      p.repost_kind === "quote" || p.repostKind === "quote"
        ? null
        : p.title ?? null,
    created_at: p.created_at || p.createdAt,
    deleted_at: p.deleted_at || p.deletedAt || null,
    is_official: Boolean(p.is_official),
    author_org: p.author_org || p.authorOrg || null,
    community: p.community || null,
    community_id: p.community_id ?? p.community?.community_id ?? null,
    social_author: p.social_author || p.socialAuthor || null,
    user: p.is_official ? null : p.user || null,
    user_id: p.is_official ? null : p.user_id ?? p.userId ?? null,
    can_delete: Boolean(p.is_official) ? false : Boolean(p.can_delete),
    removed_by_moderator: Boolean(p.removed_by_moderator),
    like_count: p.like_count ?? p.likeCount ?? 0,
    reply_count: p.reply_count ?? p.replyCount ?? 0,
    repost_count: p.repost_count ?? p.repostCount ?? 0,
    repost_kind: p.repost_kind ?? p.repostKind ?? null,
    repost_of_social_post_id: repostOfId,
    repost_of: repostOf,
    viewer_has_reposted: Boolean(p.viewer_has_reposted),
    viewer_has_liked: Boolean(p.viewer_has_liked),
  };
}
